<template>
  <div class="container v-content-container popup-wrapper">
    <!-- confirm 'book available course data' dialog -->
    <div
      class="modal fade"
      id="appointmentModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="appointmentModalLabel"
      aria-hidden="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              &times;
            </button>
            <h3 class="modal-title" id="appointmentModalLabel">
              <i class="fa fa-fw fa-lg v-warning fa-bolt"></i> Termin-Konflikte
            </h3>
          </div>

          <div class="modal-body" id="timeframeModalIntro">
            Kurstermine können nur auf freien Zeiten gelegt werden.<br /><br />
            Kollidierende Belegungen (Buchungen, anderen Kurstermine oder
            Sperren) müssen vorher freigegeben werden.
          </div>

          <div
            class="modal-body"
            id="appointmentModalBody"
            style="height:300px; overflow:auto;"
          ></div>

          <div class="modal-footer">
            <form action="#" id="delete-course-form" method="post">
              <button
                class="btn btn-default"
                data-dismiss="modal"
                aria-hidden="true"
              >
                Abbrechen
              </button>
              <button
                class="btn btn-primary"
                id="appointmentModalSubmit"
                type="submit"
              >
                Verfügbare Termine anlegen
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <h1>
          <i class="fa fa-fw fa-lg fa-list-alt"></i>
          <span v-if="selectedEventId != null">
            {{ noDataExist ? "Event" : selectedEvent.name }}
          </span>
        </h1>
      </div>
    </div>

    <navigation-tabs :event-id="selectedEventId"></navigation-tabs>

    <div class="row"><div class="col-xs-12">&nbsp;</div></div>

    <error404 v-if="noDataExist" />

    <template v-else>
      <div v-show="loading" class="row">
        <div class="col-xs-12">
          <view-loader
            margin-top-pixels="15"
            border-color="primary"
          ></view-loader>
        </div>
      </div>

      <div v-show="!loading" id="event-data-form">
        <div class="row">
          <div class="col-sm-12">
            <p></p>
            <div class="v-form-partial">
              <div class="v-form">
                <fieldset>
                  <div class="row">
                    <section class="col col-1">
                      &nbsp;
                    </section>
                    <!-- BEGIN Start date -->
                    <section class="col col-3">
                      <label class="label">{{
                        $label("event.start_date", "Start date")
                      }}</label>
                      <date-picker
                        v-model="selectedEvent.start_date"
                        :format="dateFormat"
                        :readonly="true"
                        :disabled="true"
                        :placeholder="dateFormat"
                        class="input"
                        id="event-start-date"
                        :class="{ 'text-input-error': hasError('starts_at') }"
                      >
                      </date-picker>

                      <p v-if="hasError('starts_at')" class="text-danger">
                        {{ getError("starts_at") }}
                      </p>
                    </section>
                    <!-- END Start date -->

                    <!-- BEGIN End date -->
                    <section class="col col-3">
                      <label class="label">{{
                        $label("event.end_date", "End date")
                      }}</label>
                      <date-picker
                        v-model="selectedEvent.end_date"
                        :format="dateFormat"
                        :readonly="true"
                        :disabled="true"
                        :placeholder="dateFormat"
                        class="input"
                        id="event-end-date"
                        :class="{ 'text-input-error': hasError('ends_at') }"
                      >
                      </date-picker>

                      <p v-if="hasError('ends_at')" class="text-danger">
                        {{ getError("ends_at") }}
                      </p>
                    </section>
                    <!-- END End date -->

                    <section class="col col-5">
                      <div class="pull-right">
                        <label class="label">
                          <a
                            class="text-primary"
                            href="/settings/events/venues/new"
                          >
                            <i class="fa fa-fw fa-lg fa-plus"></i>
                            {{
                              $label("common.external_venue", "External venue")
                            }}
                          </a>
                        </label>
                      </div>
                    </section>
                  </div>

                  <div>
                    <div
                      class="row"
                      v-for="weekday in weekdays"
                      v-bind:key="weekday.id"
                    >
                      <section class="col col-1">
                        <label class="label">{{ space }}</label>
                        <label
                          class="btn btn-lg btn-default v-form-button"
                          :id="'event-day-' + weekday.name"
                          :class="{ 'checked-weekday': weekday.checked }"
                          @change="toggleCheckbox(weekday.id)"
                          >{{ weekday.abbr }}
                          <input type="checkbox" class="display-none" />
                        </label>
                      </section>
                      <!-- BEGIN Start time -->
                      <section class="col col-4">
                        <label class="label">{{
                          $label("event.starts_at", "Starts at")
                        }}</label>
                        <date-picker
                          v-model="weekday.starts_at"
                          :format="timeFormat"
                          :readonly="updating"
                          :disabled="updating"
                          :placeholder="timeFormat"
                          valueType="format"
                          type="time"
                          class="input"
                          :id="'event-starts-at-' + weekday.name"
                          :class="{
                            'text-input-error': hasError(
                              'date_settings.' +
                                weekday.name +
                                '.appointments.0.starts_at'
                            )
                          }"
                        >
                        </date-picker>

                        <p
                          v-if="
                            hasError(
                              'date_settings.' +
                                weekday.name +
                                '.appointments.0.starts_at'
                            )
                          "
                          class="text-danger"
                        >
                          {{
                            getError(
                              "date_settings." +
                                weekday.name +
                                ".appointments.0.starts_at"
                            )
                          }}
                        </p>
                      </section>
                      <!-- END Start time -->

                      <!-- BEGIN End time -->
                      <section class="col col-4">
                        <label class="label">{{
                          $label("event.ends_at", "Ends at")
                        }}</label>
                        <date-picker
                          v-model="weekday.ends_at"
                          :format="timeFormat"
                          :readonly="updating"
                          :disabled="updating"
                          :placeholder="timeFormat"
                          valueType="format"
                          type="time"
                          class="input"
                          :id="'event-ends-at-' + weekday.name"
                          :class="{
                            'text-input-error': hasError(
                              'date_settings.' +
                                weekday.name +
                                '.appointments.0.ends_at'
                            )
                          }"
                        >
                        </date-picker>

                        <p
                          v-if="
                            hasError(
                              'date_settings.' +
                                weekday.name +
                                '.appointments.0.ends_at'
                            )
                          "
                          class="text-danger"
                        >
                          {{
                            getError(
                              "date_settings." +
                                weekday.name +
                                ".appointments.0.ends_at"
                            )
                          }}
                        </p>
                      </section>
                      <!-- END End time -->

                      <section v-show="venues.length > 0" class="col col-3">
                        <label class="label">{{
                          $label("venue.venue", "Venue")
                        }}</label>
                        <label class="select">
                          <select
                            class="text-capitalize"
                            :id="'event-venue-id-' + weekday.name"
                            :disabled="updating"
                            v-model="weekday.venue_id"
                          >
                            <option
                              class="text-capitalize"
                              v-for="venue in venues"
                              :key="venue.id"
                              :value="venue.id"
                              >{{ venue.name }}
                            </option>
                          </select>
                          <i></i>
                        </label>
                      </section>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4"><div class="col-xs-12">&nbsp;</div></div>

        <div class="row">
          <div class="col-xs-12 text-center">
            <back-button
              back-link="EventDetails"
              :class="{ 'is-disabled': updating }"
              id="back-event-date-settings-button"
              icon="fa fa-lg fa-fw fa-arrow-circle-o-left"
              :text="$label('common.back', 'Back')"
            >
            </back-button>
            &nbsp;
            <info-button
              :class="{ 'is-disabled': updating }"
              id="save-event-date-settings-button"
              icon="fa fa-lg fa-fw fa-save"
              :text="$label('common.save', 'Save')"
              @click.native="updateEventDateSettings"
            >
            </info-button>
          </div>
        </div>
      </div>

      <div class="row mb-4"><div class="col-xs-12">&nbsp;</div></div>
    </template>
  </div>
</template>

<script>
import Api from "@/api.js";
import FormErrorsMixin from "@/mixins/FormErrors";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import NavigationTabs from "@/components/Settings/Events/EventDetails/NavigationTabs.vue";

import ViewLoader from "@/components/Common/ViewLoader";
import InfoButton from "@/components/Common/Buttons/InfoButton";
import BackButton from "@/components/Common/Buttons/BackButton";
import Error404 from "@/components/Common/Error404";

export default {
  name: "EventDateSettings.vue",

  mixins: [FormErrorsMixin],

  components: {
    ViewLoader,
    NavigationTabs,
    InfoButton,
    BackButton,
    DatePicker,
    Error404
  },

  data() {
    return {
      loading: false,
      updating: false,
      noDataExist: false,
      space: "\xa0",
      dateFormat: "DD.MM.YYYY",
      dateTimeFormat: "DD.MM.YYYY HH:mm:ss",
      timeFormat: "HH:mm:ss",
      venues: [],
      weekdays: [
        {
          id: 0,
          abbr: "MO",
          name: "monday",
          checked: false,
          starts_at: null,
          ends_at: null,
          venue_id: 1
        },
        {
          id: 1,
          abbr: "TU",
          name: "tuesday",
          checked: false,
          starts_at: null,
          ends_at: null,
          venue_id: 1
        },
        {
          id: 2,
          abbr: "WE",
          name: "wednesday",
          checked: false,
          starts_at: null,
          ends_at: null,
          venue_id: 1
        },
        {
          id: 3,
          abbr: "TH",
          name: "thursday",
          checked: false,
          starts_at: null,
          ends_at: null,
          venue_id: 1
        },
        {
          id: 4,
          abbr: "FR",
          name: "friday",
          checked: false,
          starts_at: null,
          ends_at: null,
          venue_id: 1
        },
        {
          id: 5,
          abbr: "SA",
          name: "saturday",
          checked: false,
          starts_at: null,
          ends_at: null,
          venue_id: 1
        },
        {
          id: 6,
          abbr: "SU",
          name: "sunday",
          checked: false,
          starts_at: null,
          ends_at: null,
          venue_id: 1
        }
      ],

      selectedEventId: null,
      selectedEvent: {
        name: null,
        start_date: null,
        end_date: null
      },

      eventDateSettings: {
        date_settings: {
          monday: {
            appointments: [
              {
                starts_at: null,
                ends_at: null,
                venue_id: null
              }
            ]
          },
          tuesday: {
            appointments: [
              {
                starts_at: null,
                ends_at: null,
                venue_id: null
              }
            ]
          },
          wednesday: {
            appointments: [
              {
                starts_at: null,
                ends_at: null,
                venue_id: null
              }
            ]
          },
          thursday: {
            appointments: [
              {
                starts_at: null,
                ends_at: null,
                venue_id: null
              }
            ]
          },
          friday: {
            appointments: [
              {
                starts_at: null,
                ends_at: null,
                venue_id: null
              }
            ]
          },
          saturday: {
            appointments: [
              {
                starts_at: null,
                ends_at: null,
                venue_id: null
              }
            ]
          },
          sunday: {
            appointments: [
              {
                starts_at: null,
                ends_at: null,
                venue_id: null
              }
            ]
          }
        }
      },
      validatedInputs: [
        "starts_at",
        "ends_at",
        "date_settings.monday.appointments.0.starts_at",
        "date_settings.monday.appointments.0.ends_at",
        "date_settings.monday.appointments.0.venue_id",
        "date_settings.tuesday.appointments.0.starts_at",
        "date_settings.tuesday.appointments.0.ends_at",
        "date_settings.tuesday.appointments.0.venue_id",
        "date_settings.wednesday.appointments.0.starts_at",
        "date_settings.wednesday.appointments.0.ends_at",
        "date_settings.wednesday.appointments.0.venue_id",
        "date_settings.thursday.appointments.0.starts_at",
        "date_settings.thursday.appointments.0.ends_at",
        "date_settings.thursday.appointments.0.venue_id",
        "date_settings.friday.appointments.0.starts_at",
        "date_settings.friday.appointments.0.ends_at",
        "date_settings.friday.appointments.0.venue_id",
        "date_settings.saturday.appointments.0.starts_at",
        "date_settings.saturday.appointments.0.ends_at",
        "date_settings.saturday.appointments.0.venue_id",
        "date_settings.sunday.appointments.0.starts_at",
        "date_settings.sunday.appointments.0.ends_at",
        "date_settings.sunday.appointments.0.venue_id"
      ]
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.selectedEventId = vm.$route.params.event_id;
      if (
        typeof vm.selectedEventId !== "undefined" &&
        vm.selectedEventId !== null
      ) {
        vm.getVenues(() => {
          //
        });
        vm.getEvent(() => {
          //
        });
        vm.getEventDateSettings(() => {
          //
        });
      } else {
        this.$router.push({
          name: "Events"
        });
      }
    });
  },

  beforeRouteUpdate(to, from, next) {
    if (
      typeof this.selectedEventId !== "undefined" &&
      this.selectedEventId !== null
    ) {
      this.getVenues(() => {
        //
      });
      this.getEvent(() => {
        //
      });
      this.getEventDateSettings(() => {
        //
      });
    } else {
      this.$router.push({
        name: "Events"
      });
    }
    next();
  },

  mounted() {
    //
  },

  methods: {
    toggleCheckbox(weekdayId) {
      this.weekdays[weekdayId].checked = !this.weekdays[weekdayId].checked;
    },

    getEventDateSettings() {
      this.resetErrors();
      this.loading = true;
      const endpoint = this.$partnerEndpoint(
        "events/" + this.selectedEventId + "/date-settings"
      );

      Api()
        .get(endpoint)
        .then(response => {
          for (let i = 0; i < this.weekdays.length; i++) {
            if (
              response.data.date_settings[this.weekdays[i].name].appointments
                .length > 0
            ) {
              this.weekdays[i].checked = true;
              this.weekdays[i].starts_at =
                response.data.date_settings[
                  this.weekdays[i].name
                ].appointments[0].starts_at;
              this.weekdays[i].ends_at =
                response.data.date_settings[
                  this.weekdays[i].name
                ].appointments[0].ends_at;
              this.weekdays[i].venue_id =
                response.data.date_settings[
                  this.weekdays[i].name
                ].appointments[0].venue_id;
            } else {
              this.weekdays[i].checked = false;
              this.weekdays[i].starts_at = null;
              this.weekdays[i].ends_at = null;
            }
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateEventDateSettings() {
      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint(
        "events/" + this.selectedEventId + "/date-settings"
      );

      for (let i = 0; i < this.weekdays.length; i++) {
        if (
          this.weekdays[i].checked &&
          this.weekdays[i].starts_at != null &&
          this.weekdays[i].ends_at != null
        ) {
          this.eventDateSettings.date_settings[
            this.weekdays[i].name
          ].appointments[0] = {
            starts_at: this.weekdays[i].starts_at,
            ends_at: this.weekdays[i].ends_at,
            venue_id: this.weekdays[i].venue_id
          };
        } else {
          this.eventDateSettings.date_settings[
            this.weekdays[i].name
          ].appointments = [];
        }
      }

      Api()
        .put(endpoint, this.eventDateSettings)
        .then(() => {
          this.getEventDateSettings();
        })
        .catch(error => {
          console.log(error);
          this.storeErrors(error.response.data.errors);
        })
        .finally(() => {
          this.updating = false;
        });
    },

    getEvent() {
      this.resetErrors();
      this.loading = true;
      const endpoint = this.$partnerEndpoint("events/" + this.selectedEventId);

      Api()
        .get(endpoint)
        .then(response => {
          this.selectedEvent = response.data.data;
          this.selectedEvent.start_date = this.convertDate(
            this.selectedEvent.start_date,
            response.data.data.start_date
          );
          this.selectedEvent.end_date = this.convertDate(
            this.selectedEvent.end_date,
            response.data.data.end_date
          );
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.noDataExist = true;
          }
          console.log(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getVenues(successCallback) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.venues = [];
      const endpoint = this.$partnerEndpoint("venues");

      Api()
        .get(endpoint, {
          params: {
            page: 1,
            search: ""
          }
        })
        .then(response => {
          this.venues = response.data.data;
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.mb-4 {
  margin-bottom: 1.2rem;
}

.display-none {
  display: none;
}

.checked-weekday {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
}
</style>
